import { useEditor } from "./useEditor";

export const useCommandManager = () => {
	const { commandManager } = useEditor();

	return commandManager;
};
